import { useContext } from "react";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

import { Input } from "components/common/basic";
import { PopupVariant, PopupWrapper } from "components/common/popups";
import { useUpdateAccountMutation } from "graphql/mutations";
import { useErrorLogger } from "hooks";
import { PopupContext } from "providers/PopupHandler";
import { useTranslation } from "translations";

interface FormValues {
  email: string;
}

interface Props {
  hasPrevious: boolean;
  variant: PopupVariant;
}

export default (props: Props): React.JSX.Element => {
  const { updateAccount } = useUpdateAccountMutation();

  const { t } = useTranslation("account");
  const { closeOnePopup } = useContext(PopupContext);

  const validationSchema = Yup.object({
    email: Yup.string().required(),
  });

  const {
    formState: { errors, isValid },
    handleSubmit,
    register,
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const { reportErrors } = useErrorLogger();
  reportErrors(errors);

  const onSubmit = (attributes: FormValues) =>
    updateAccount({ attributes }, closeOnePopup);

  const formId = "phoneNumberForm";

  return (
    <PopupWrapper
      {...props}
      nameSpace="account"
      title={t("accountSettings.emailPopup.heading", "Add an email address")}
      subTitle={t(
        "accountSettings.emailPopup.description",
        "We will send an email to the address added below. Please click the link in the email to verity the new email."
      )}
      footerActions={[
        {
          id: "accountSettings-add_email",
          type: "submit",
          form: formId,
          variant: "primary",
          label: t(
            "accountSettings.emailPopup.button.submit",
            "Verify email address"
          ),
          disabled: !isValid,
        },
      ]}
    >
      <form onSubmit={handleSubmit(onSubmit)} id={formId}>
        <Input
          id="email"
          label={t("accountSettings.emailPopup.email.label", "Email")}
          {...register("email")}
        />
      </form>
    </PopupWrapper>
  );
};
